var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Box, Divider, Grid, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Cell, Pie, PieChart } from "recharts";
import { sleep } from "../../../../builderPackage/common/commonFunctions";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { secondary } from "../../../../theme/colors";
import { PSGDashboardHeader } from "../components/PSGDashboardHeader";
import { DesktopTabComponent } from "../../../../components/molecules/desktopTabComponent";
var COLORS = ["#3697FF", "#FFAB00", "#7D5EFA", "#52C41A", "#FF4671", "#1B1D21"];
var AFRCOLORS = ["#52C41A", "#FFAB00", "#1DC8DF", "#1B1D21"];
// const generateColors = (count: any) => {
//     const colors = ["#144C8C", '#8AB9EE', "#3E3B44", "#90B08A", "#17866F", "#C1B78B", "#784F3B", "#DABD5D", "#FFA726", "#7E57C2", "#26A69A", "#EC407A", "#AB47BC"];
//     return Array.from({ length: count }, (_, i) => colors[i % colors.length]);
// };
var generateColors = function (key, count) {
    switch (key) {
        case "AFRs":
            return AFRCOLORS.slice(0, count);
        case "IRs":
            return COLORS.slice(0, count);
        default:
            // fallback: cycle through COLORS
            return Array.from({
                length: count
            }, function (_, i) { return COLORS[i % COLORS.length]; });
    }
};
export var PSGDashboard = function (props) {
    var crud = useAppSelector(function (state) { return state.crud; });
    var AFRSDATA = crud === null || crud === void 0 ? void 0 : crud.DashboardCountAFR;
    var IRSDATA = crud === null || crud === void 0 ? void 0 : crud.DashboardCountIR;
    // const { dashboardCount } = props
    var dispatch = useAppDispatch();
    var dashboardCount = {
        AFRs: [{
                name: "Reverted",
                count: AFRSDATA === null || AFRSDATA === void 0 ? void 0 : AFRSDATA.Reverted
            }, {
                name: "Closed",
                count: AFRSDATA === null || AFRSDATA === void 0 ? void 0 : AFRSDATA.Closed
            }, {
                name: "Resubmitted",
                count: AFRSDATA === null || AFRSDATA === void 0 ? void 0 : AFRSDATA.Resubmitted
            }, {
                name: "Received",
                count: AFRSDATA === null || AFRSDATA === void 0 ? void 0 : AFRSDATA.Received
            }],
        IRs: [{
                name: "Reverted",
                count: IRSDATA === null || IRSDATA === void 0 ? void 0 : IRSDATA.Reverted
            }, {
                name: "Closed",
                count: IRSDATA === null || IRSDATA === void 0 ? void 0 : IRSDATA.Closed
            }, {
                name: "Submitted",
                count: IRSDATA === null || IRSDATA === void 0 ? void 0 : IRSDATA.Submitted
            }, {
                name: "Lapsed",
                count: IRSDATA === null || IRSDATA === void 0 ? void 0 : IRSDATA.Lapsed
            }, {
                name: "Resubmitted",
                count: IRSDATA === null || IRSDATA === void 0 ? void 0 : IRSDATA.Resubmitted
            }, {
                name: "Corrective Action taken",
                //add corrective Action taken
                count: (IRSDATA === null || IRSDATA === void 0 ? void 0 : IRSDATA.CorrectiveActionTaken) || 0
            }],
        Services: [{
                name: "Product",
                count: 639
            }, {
                name: "Part",
                count: 1728
            }],
        xys: [{
                name: "Product",
                count: 639
            }, {
                name: "Part",
                count: 2728
            }]
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DesktopTabComponent, null), /*#__PURE__*/ React.createElement(PSGDashboardHeader, null), /*#__PURE__*/ React.createElement(Stack, {
        minHeight: "inherit",
        width: "100%"
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        minWidth: 200,
        gap: 2,
        display: "flex",
        justifyContent: "center",
        p: "10px"
    }, dashboardCount ? Object.keys(dashboardCount).map(function (key, i) {
        var colors = generateColors(key, dashboardCount[key].length);
        var getLabel = function (key) {
            switch (true) {
                case key === "AFRs":
                    return "AFRs";
                    break;
                case key === "IRs":
                    return "IRs";
                    break;
                case key === "Services":
                    return "Accepted IRs by CQA Vs Corrective action taken Vs Partially Closed IRS";
                    break;
                case key === "xys":
                    return "Corrective action taken model group wise";
                    break;
                default:
                    return "Label";
                    break;
            }
        };
        return /*#__PURE__*/ React.createElement(Box, {
            sx: {
                backgroundColor: "white",
                borderRadius: 2,
                boxShadow: 1,
                p: 2,
                width: {
                    xs: window.innerWidth / 1,
                    sm: window.innerWidth / 1,
                    md: window.innerWidth / 2.4,
                    xl: window.innerWidth / 2.2
                }
            }
        }, /*#__PURE__*/ React.createElement(Stack, {
            direction: "row",
            justifyContent: "space-between",
            sx: {
                alignItems: "center"
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            fontWeight: "bold",
            sx: {
                textWrap: "wrap",
                width: {
                    xs: "50%",
                    md: "100%"
                }
            }
        }, getLabel(key))), /*#__PURE__*/ React.createElement(Divider, {
            sx: {
                my: 2
            }
        }), /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            alignItems: "center",
            justifyContent: "space-between"
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            sm: 8,
            xs: 12
        }, /*#__PURE__*/ React.createElement(Doughnut, {
            data: dashboardCount[key],
            colors: colors,
            delay: 1000,
            options: {
                responsive: true,
                maintainAspectRatio: false
            }
        })), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            sm: 4,
            xs: 12
        }, /*#__PURE__*/ React.createElement(Stack, {
            spacing: 1
        }, dashboardCount[key].map(function (item, index) { /*#__PURE__*/ return React.createElement(Stack, {
            direction: "row",
            spacing: 1,
            alignItems: "center",
            key: index
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                width: 35,
                height: 35,
                backgroundColor: colors[index] || "#CCC",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "10px",
                fontWeight: "bold",
                color: "#fff"
            }
        }), /*#__PURE__*/ React.createElement(Typography, {
            variant: "h5",
            fontSize: "base",
            fontWeight: "small",
            color: secondary[500]
        }, item.name)); })))));
    }) : /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        md: 4
    }, /*#__PURE__*/ React.createElement(Doughnut, {
        data: null,
        headerLabel: "Data"
    })))));
};
export var Doughnut = function (props) {
    var data = props.data, colors = props.colors, delay = props.delay;
    var _a = useState([{
            name: "",
            count: 0
        }]), pieData = _a[0], setPieData = _a[1];
    var handleGetdata = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, sleep(delay)];
                case 1:
                    _a.sent();
                    if (data)
                        setPieData(data);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        handleGetdata(data);
    }, [data]);
    var totalCount = pieData.reduce(function (acc, item) { return acc + item.count || 0; }, 0);
    // 🏷️ Custom label renderer
    var renderCustomLabel = function (_ref) {
        var _pieData$index;
        var cx = _ref.cx, cy = _ref.cy, midAngle = _ref.midAngle, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, percent = _ref.percent, index = _ref.index;
        var RADIAN = Math.PI / 180;
        var radius = innerRadius + (outerRadius - innerRadius) / 2;
        var x = cx + radius * Math.cos(-midAngle * RADIAN);
        var y = cy + radius * Math.sin(-midAngle * RADIAN);
        var value = (_pieData$index = pieData[index]) === null || _pieData$index === void 0 ? void 0 : _pieData$index.count;
        return /*#__PURE__*/ React.createElement("text", {
            x: x,
            y: y,
            fill: "white",
            textAnchor: "middle",
            dominantBaseline: "central",
            fontSize: 14,
            fontWeight: "bold"
        }, value);
    };
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            position: "relative",
            width: "400px",
            height: "340px"
        }
    }, /*#__PURE__*/ React.createElement(PieChart, {
        width: 400,
        height: 340
    }, /*#__PURE__*/ React.createElement(Pie, {
        data: pieData,
        dataKey: "count",
        cx: "50%",
        cy: "50%",
        outerRadius: 120,
        innerRadius: 60,
        paddingAngle: 2,
        cornerRadius: 5,
        label: renderCustomLabel,
        labelLine: false,
        isAnimationActive: true
    }, pieData.map(function (entry, index) { /*#__PURE__*/ return React.createElement(Cell, {
        key: "cell-".concat(index),
        fill: colors ? colors[index % colors.length] : "#CCC"
    }); }))), /*#__PURE__*/ React.createElement("div", {
        style: {
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            fontSize: "32px",
            fontWeight: "bold",
            color: "#1a1a1a",
            textAlign: "center",
            pointerEvents: "none"
        }
    }, totalCount));
};
